module.exports = __webpack_public_path__ + "img/chat_bot_2.96892a75.png";